import { Navigate } from "react-router";

const PrivateRoute = ({ children }: any) => {
  const getRefreshToken = () => localStorage.getItem("refreshToken");

  if (!getRefreshToken()) return <Navigate to="/login" replace />;

  return <>{children}</>;
};

export default PrivateRoute;
